/**
 * isRecord narrows a decoded JSON value to an object (not an array, not null).
 * A leaf module with no imports, so the platform client and the apps' pure
 * libraries (run by bun outside a browser) share the one guard.
 */
export function isRecord(v: unknown): v is Record<string, unknown> {
  return typeof v === 'object' && v !== null && !Array.isArray(v)
}
